import { gql, useMutation } from '@apollo/client';

import { GET_CART_QUERY } from '@/helpers/apollo/queries/cart';
import { createCartMutation } from '@/helpers/big-commerce/mutations/cart';

export const useCartOperations = () => {
  const [
    createCart,
    {
      data: createCartData,
      loading: createCartLoading,
      error: createCartError,
    },
  ] = useMutation(gql(createCartMutation), {
    refetchQueries: [GET_CART_QUERY],
  });

  // const [
  //   createCart,
  //   {
  //     data: createCartData,
  //     loading: createCartLoading,
  //     error: createCartError,
  //   },
  // ] = useMutation(createCartMutation);

  // const [
  //   editCartItems,
  //   {
  //     data: editCartItemsData,
  //     loading: editCartItemsLoading,
  //     error: editCartItemsError,
  //   },
  // ] = useMutation(editCartItemsMutation, {
  //   refetchQueries: [GET_CART_QUERY],
  // });

  // const [
  //   removeFromCart,
  //   {
  //     data: removeFromCartData,
  //     loading: removeFromCartLoading,
  //     error: removeFromCartError,
  //   },
  // ] = useMutation(removeFromCartMutation);

  return {
    createCart,
    // createCart,
    // editCartItems,
    // removeFromCart,
    loading: createCartLoading,
    // createCartLoading ||
    // editCartItemsLoading ||
    // removeFromCartLoading,
    error: createCartError,
    // createCartError ||
    // editCartItemsError ||
    // removeFromCartError,
    data: {
      createCartData,
      // createCartData,
      // editCartItemsData,
      // removeFromCartData,
    },
  };
};
